<template>
  <div>
    <div>
      <div tabindex="0" class="e-card" >
        <div class="e-card-title">Change Password</div>
        <div class="e-card-content margin-color-verify-section">
          <div>
            <h4 class="title-color">Password update Information</h4>
          </div>
          <div class="e-card-separator"></div>
          <span style="color: red; display: block; margin-bottom: 2%">
            {{ notifyErrorMessage }}</span
          >
          <span style="color: green; display: block; margin-bottom: 2%">
            {{ notifySuccessMessage }}</span
          >
          <web-login-info
            ref="refwebLoginInfo"
            :userProfileId="userId"
            :userProfilesData="currentUser"
          />
          <div class="align-center-bottom">
            <ejs-button
              type="button"
              v-on:click.native="btnComplete"
              cssClass="e-info margin-button"
              >Submit</ejs-button
            >
            <ejs-button
              type="button"
              v-on:click.native="onCancelButtonClick"
              cssClass="e-danger margin-button"
              >Cancel</ejs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WebLoginInfo from '../components/web-login-info.vue';
import { FETCH_USER_BY_ID } from '../../auth/store';

export default {
  name: 'UpdatePassword',
  components: {
    WebLoginInfo,
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
      currentUser: 'userById',
    }),
    userId() {
      return this.loggedUser?.id;
    },
  },
  watch: {
    userId(userId) {
      this.$store.dispatch(FETCH_USER_BY_ID, { userId });
    },
  },
  data() {
    return {
      notifyErrorMessage: '',
      notifySuccessMessage: '',
      response: null,
    };
  },
  created() {
    if (this.userId) { this.$store.dispatch(FETCH_USER_BY_ID, { userId: this.userId }); }
  },
  methods: {
    onCancelButtonClick() {
      this.$router.push('/');
    },
    async btnComplete() {
      const loginInfo = this.$refs.refwebLoginInfo;
      if (
        loginInfo.isOldPasswordValid
        && loginInfo.isPasswordValid
        && loginInfo.isConfirmPassword
      ) {
        try {
          await loginInfo.changePassword().then(() => {
            this.response = this.$store.getters.chnagePasswordResponse;
            if (this.response === 'SUCCESS') {
              this.notifyErrorMessage = '';
              this.notifySuccessMessage = 'Your password has successfully changed.';
              this.$parent.notificationToasts.push({
                title: 'Success!',
                content: this.notifySuccessMessage,
                cssClass: 'e-toast-success',
                timeOut: 5000,
              });
              this.$router.push('/email-sent');
            } else {
              this.notifySuccessMessage = '';
              this.notifyErrorMessage = `${this.response}`;
              this.$parent.notificationToasts.push({
                title: 'Error!',
                content: this.notifyErrorMessage,
                cssClass: 'e-toast-danger',
                timeOut: 5000,
              });
            }
          });
        } catch (err) {
          this.notifySuccessMessage = '';
          this.notifyErrorMessage = 'Please enter value in required fields.';
          this.$parent.notificationToasts.push({
            title: 'Error!',
            content: this.notifyErrorMessage,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
      } else {
        this.notifySuccessMessage = '';
        this.notifyErrorMessage = '';
        if (!loginInfo.isOldPasswordValid) {
          this.notifyErrorMessage = 'Existing Password is required field.';
        }
        if (!loginInfo.isPasswordValid) {
          this.notifyErrorMessage += ' New password is not valid.';
        }
        if (!loginInfo.isConfirmPassword) {
          this.notifyErrorMessage += ' Please confirm password.';
        }
        loginInfo.validatePassword();
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: this.notifyErrorMessage,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>

<style>
.align-center-bottom {
  display: block;
  text-align: center;
  /* margin-top: 1px; */
}
.align-center-signin {
  margin: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.margin-button {
  margin: 25px 5px 20px 20px;
}
</style>
